import { HeaderModule } from '@app/components/header/header.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BannerModule } from '@app/components/banner/banner.module';
import { CarouselModule } from '@app/components/carousel/carousel.module';
import { ContainerScrollModule } from '@app/components/container-scroll/container-scroll.module';
import { IconsModule } from '@app/components/icons/icons.module';
import { ListItemsModule } from '@app/components/list-items/list-items.module';
import { SharedModule } from '@app/shared/shared.module';

import { ListItemShopComponent } from './list-item-shop/list-item-shop.component';
import { ShopRoutingModule } from './shop-routing.module';
import { ShopComponent } from './shop/shop.component';

@NgModule({
  declarations: [
    ShopComponent,
    ListItemShopComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BannerModule,
    ShopRoutingModule,
    CarouselModule,
    IconsModule,
    ListItemsModule,
    BannerModule,
    ContainerScrollModule,
    HeaderModule
  ],
  entryComponents: []
})
export class ShopModule { }
